import React, { useEffect, useState } from 'react';
import OrderDetailsBody from './order-details-body';
import OrderDetailsHeader from './order-details-header';
import './styles.scss';
import { OrderDetailsType, OrderType } from 'models/order.model';
import { formatNumber, getNameFromOrder, getOrderStatus, getUserName } from 'utils/functions';
import styles from '../index.module.css';
import { ENUM_STATUS } from 'utils/enum';
import OrderUpdateModal from './order-update-modal';

type Props = {
  order: OrderType;
};

type MealAccordionType = {
  user_name: string;
  meals: OrderDetailsType[];
};

export const OrderDetailsInfo = ({ order }: Props) => {
  const [showAll] = useState(true);

  const calcOrder = order?.calculated_order;

  const numberOfBrands = calcOrder?.brand_ids?.length;
  const numberOfMeals = (calcOrder?.meals ?? []).reduce((mealsAcc, meal) => {
    const innerMeals = meal?.meals?.length;
    mealsAcc += innerMeals;
    return mealsAcc;
  }, 0);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const [open, setOpen] = useState<string[]>(['0']);
  const handleOpenAccordion = (name: string) => {
    if (open?.includes(name)) {
      const filteredIdx = open?.filter((brandName) => brandName !== name);
      setOpen(filteredIdx);
    } else {
      setOpen([...open, name]);
    }
  };

  const idxArr: string[] = [];

  const brands = order?.calculated_order?.meals ?? [];
  const subBrands = order?.calculated_order?.sub_calculated_order_ids ?? [];
  const orderDetails = brands.map((brand, idx) => {
    idxArr.push(String(idx));
    return {
      id: brand.brand.id,
      brand: brand.brand?.name,
      amount: brand.amount,
      quantity: 1,
      meal: (brand?.meals ?? []).map((meal) => {
        return {
          id: meal.id,
          meal: meal.name,
          amount: meal.amount,
          quantity: meal.quantity,
          order_note: meal.order_note,
          addons: meal?.addons?.map((addon) => {
            return {
              id: addon.id,
              name: addon.name ?? addon.meal_data?.name,
              quantity: addon?.quantity
            };
          })
        };
      })
    };
  });

  const subGroupOrder: MealAccordionType[] = [];
  subBrands.forEach((item) => {
    const name = getUserName(item.user);

    const arr = {
      user_name: name,
      meals: (item.meals ?? []).map((brand, i) => {
        idxArr.push(String(i + name));
        return {
          id: brand.brand.id,
          brand: brand.brand.name,
          amount: brand.amount,
          quantity: 1,
          meal: (brand?.meals ?? []).map((meal) => {
            return {
              id: meal.id,
              meal: meal.name,
              amount: meal.amount,
              quantity: meal.quantity,
              order_note: meal.order_note,
              addons: meal.addons?.map((addon) => {
                return {
                  id: addon.id,
                  name: addon.name ?? addon.meal_data?.name,
                  quantity: addon.quantity || ''
                };
              })
            };
          })
        };
      })
    };
    subGroupOrder.push(arr);
  });

  const isGroupOrder = order?.calculated_order?.is_group_order;
  const fullName = getNameFromOrder(order);

  useEffect(() => {
    if (showAll) {
      setOpen(idxArr);
    } else {
      setOpen([]);
    }
  }, [showAll]);

  return (
    <div className={`${styles['section']} text-gray-5 overflow-y-auto h-full`}>
      <OrderDetailsHeader
        totalOrderAmount={formatNumber(calcOrder?.total_amount)}
        totalNoOfItems={numberOfMeals}
        totalNoOfBrands={numberOfBrands}
        note={order?.cancelled_note}
        isProcessing={getOrderStatus(order) === ENUM_STATUS.PROCESSING}
        cutlery={order.order_details.cutlery}
        setShowUpdateModal={() => setShowUpdateModal(true)}
      />
      <OrderDetailsBody
        isGroupOrder={isGroupOrder ?? false}
        fullName={fullName}
        orderDetails={orderDetails}
        open={open}
        handleOpenAccordion={handleOpenAccordion}
        subGroupOrder={subGroupOrder}
      />
      <OrderUpdateModal
        isOpen={showUpdateModal}
        closeUpdateModal={() => setShowUpdateModal(false)}
        orderDetails={orderDetails}
        totalNoOfItems={numberOfMeals}
        totalNoOfBrands={numberOfBrands}
        order={order}
      />
    </div>
  );
};

export default OrderDetailsInfo;
